import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress
} from '@mui/material';
import colors from '../theme/Colors';
import moment from 'moment';

const RateBox = ({ dialogOpen, selectedRate, handleCloseDialog, loading }) => {
  console.log(selectedRate, 'selectedRate');
  return (
    <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
      <DialogTitle style={{ textAlign: 'center', color: colors.primary }}>
        Rate History
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
              <Table>
                <TableBody>
                  {/* Rate Row */}
                  <TableRow>
                    <TableCell 
                      sx={{ 
                        textAlign: 'center',
                        border: '1px solid black',
                        fontWeight: 'bold'
                      }}
                    >
                      Rate
                    </TableCell>
                    {selectedRate?.history?.map((historyItem, index) => (
                      <TableCell 
                        key={`rate-${index}`}
                        sx={{ 
                          textAlign: 'center',
                          border: '1px solid black',
                          minWidth: '100px'
                        }}
                      >
                        {historyItem.previous_price}
                      </TableCell>
                    ))}
               
                  </TableRow>

                  {/* Date Row */}
                  <TableRow>
                    <TableCell 
                      sx={{ 
                        textAlign: 'center',
                        border: '1px solid black',
                        fontWeight: 'bold'
                      }}
                    >
                      Date
                      </TableCell>
                      {selectedRate?.history?.map((historyItem, index) => (
                      <TableCell 
                        key={`date-${index}`}
                        sx={{ 
                          textAlign: 'center',
                          border: '1px solid black',
                          minWidth: '100px'
                        }}
                      >
                        {moment(historyItem.updated_date).format('D/M/YYYY')}
                      </TableCell>
                    ))}
                  
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseDialog}
          style={{
            backgroundColor: colors.primary,
            color: 'black',
            margin: '16px',
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RateBox;
